/* eslint-disable no-undef */
(function ($) {
  const mql = window.matchMedia('(min-width: 1024px)');

  function searchHandler(e) {
    let currentPos = '';

    if (e.matches) {
      $('.js-search-toggle').off('click');
      $('.js-search-toggle').on('click', function () {
        $('body')
          .toggleClass('is-search-open')
          .removeClass('is-nav-open');
        $(this).toggleClass('is-active');
        $('.js-nav-toggle').removeClass('is-active');

        const formControl = $(this).parent().find('.form-control');

        formControl.val('').focus();
      });
    } else {
      let savedPos = '';

      // navigation toggle
      $('.js-search-toggle').off('click');
      $('.js-search-toggle').on('click', function () {
        // Get current position
        currentPos = window.pageYOffset;

        // Save position on opening clicks only
        const click = $(this).data('clicks');
        if (!click) {
          $(this).attr('data-pos', currentPos);
        }
        $(this).data('clicks', !click);

        $('body')
          .toggleClass('is-search-open')
          .removeClass('is-nav-open');
        $(this).toggleClass('is-active');
        $('.js-nav-toggle').removeClass('is-active');

        const formControl = $(this).parent().find('.form-control');

        formControl.val('').focus();

        // Save the scroll position when menu is open
        if ($('body').hasClass('is-search-open')) {
          $('body.is-search-open').css({'top': '-' + currentPos + 'px' });
        } else {
          $('body').css({'top': 'auto',});
          $('#search_input').blur();
          savedPos = $(this).attr('data-pos');
          $(window).scrollTop(savedPos); // Use saved position to return the page to that state after menu is closed
        }
      });
    }
  }

  mql.addListener(searchHandler);
  searchHandler(mql);
}(jQuery));
